export const ORG_CD_TYPE = [
  { label: "여신금융", value: "cardsales" },
  { label: "홈택스", value: "hometax" },
  { label: "개인카드", value: "card" },
  { label: "법인카드", value: "ccd" },
  { label: "개인뱅킹", value: "pbk" },
  { label: "법인뱅킹", value: "cbk" }
]

export const SCRAPING_STATE = [
  { label: "성공", value: 1 },
  { label: "실패", value: 2 },
  { label: "수집대기", value: 9 },
]

export const SVC_CD_TYPE = [
  { label: "매입 계산서 내역", value: "Z3004" },
  { label: "매출 계산서 내역", value: "Z3003" },
  { label: "매입 세금 계산서 내역", value: "Z3002" },
  { label: "매출 세금 계산서 내역", value: "Z3001" },
  { label: "매입 현금영수증 내역", value: "Z4002" },
  { label: "매출 현금영수증 내역", value: "Z4001" },
  { label: "매출 내역 ", value: "B0021" },
  { label: "입금 내역", value: "B0031" },
  { label: "승인 내역", value: "C0005" },
  { label: "거래 내역", value: "B0002" },
]

export const FINANCE_SCRAPING_STATE = [
  { label: '사용중지', value: 0, color: 'light' },
  { label: "스크래핑중", value: 1, color: 'success' },
  { label: "에러", value: 2, color: 'danger' },
  { label: "대기", value: 9, color: 'primary' },
]

// 0: 사용 중지 (사라진 카드 또는 계좌)

// 1: 스크래핑중 (이에따른 화면 처리 필요)

// 2: 에러 (다음 스크래핑시 제외됨)

// 9: 대기 (자동 스크래핑 가능상태